module.exports = __webpack_public_path__ + "img/nf.304f6b9b.svg";